<template>  
    <div>
        <div class="row filter_row align-items-start" v-if="skeleton">
            <div class="mb-2 col-md-12 placeholder-glow" >
                    <div class="placeholder mr-2 mb-2 rounded" style="height: 20px; width: 50px;"></div>
               
            </div>
            <div class="pt-2 col-md-12">
                <div class="shape_flex">
                    <div class="filter_row">
                        <div  v-for="option in 10" :key="option" class="filterbox tooltip_box border-0 placeholder-glow">
                            <div class="placeholder mb-0 rounded" style="height: 100%; width: 100%;"></div>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div  v-if="options" name="custom-transition" mode="out-in" >
            <div v-show="!skeleton&&filter&&options" class="row filter_row align-items-start">
                <div  class="col-12 mb-2"><span class="filter_title">{{ filter.label }}</span></div >
                <div class="col-12 pt-2">
                    <div class="shape_flex">
                        <div class="filter_row filter_row_mod">
                            <div    
                                v-for="option in options"
                                :key="option.id"
                                class="filterbox tooltip_box"
                                :class="{ 'active' : option.active === 1,  'disabled' : option.disabled === 1 }"
                                @click="change(option)"
                                :data-id="option.id"
                            >
                                <SvgShapeSvg v-if="option.active === 0" :type="option.value" />
                                <SvgShapeSvg v-if="option.active === 1" :type="option.value + '_active'" />
                                <div class="for_mobile shape_label">{{ option.label }}</div>
                                <div class="tooltip_text for_desktop">
                                    <span v-if="option.disabled === 1">Not available</span>
                                    <span v-else>{{ option.label }}</span>
                                   
                                </div>
                            </div>
                            <div class="filterbox_mod">
                                <DiamondFilterFieryRoundBoxFilter name="fiery_round"/>
                            </div>
                            
                        </div>
                    </div>
                </div >
            </div>
        </div>
        
    </div>


</template>


<script setup>
    import { ref, computed, inject, onMounted, watch } from 'vue'
    import {cyolistStore}  from '@/stores/cyolist/cyolist';
    
    
    const skeleton = ref(true)
    const props = defineProps(['name'])
    const moduleSubType = inject('moduleSubType')
    const moduleType = inject('moduleType')
    const store = cyolistStore();

    const filter = computed(() => {
        return store.getSettingFilter(moduleSubType, props.name);
    });

    const options = computed(() => {
        // console.log('store.getSettingFilterOptions(moduleSubType, props.name)', store.getSettingFilterOptions(moduleSubType, props.name))
        return store.getSettingFilterOptions(moduleSubType, props.name);
    });

    const change = (option) => {
        if (option.disabled) {
            return
        }
        store.toggleSettingFilter( { reset: false, type: moduleSubType, filter: filter.value, option } )
    }

    watch(options, (newOptions) => {
    if (newOptions) {
        skeleton.value = false
    }
    }, { immediate: true })

    onMounted(() => {
        if (options.value) {
            skeleton.value = false
        }
    })
</script>

  

<style scoped>
.placeholder{
    background-color: rgba(0, 0, 0, 0.3);
}
.tooltip_box .tooltip_text {
    min-width: 80px;
    width: auto;
    padding: 3px 5px;
    margin-left: -40px;
}
.center_col {
    padding: 0 2% !important;
}
.left_col {
    padding-right: 2% !important;
}
.right_col {
    padding-left: 2% !important;
}
.disabled{
    opacity: 0.3;
    cursor: not-allowed !important;
}



@media(max-width: 992px){
    .filterbox img {
        width: 25px;
    }
    .filterbox{
        width: 40px !important;
        height: 40px !important;
        margin: 0 2% 2% 0 !important;
    }
    .center_col {
        padding: 0 2% !important;
            height: 90px;
            margin: 0 !important;
    }
    .left_col {
        padding: 0 2% !important;
            height: 90px;
            margin: 0 !important;
    }
    .right_col {
        padding: 0 2% !important;
            height: 90px;
            margin: 0 !important;
    } 
}
.filterbox {
    width: 40px;
    height: 40px;
    border: solid 1px #c6cbd4;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 1.5% 1.5% 0;
    cursor: pointer;
}
.filterbox.active {
    /*border: 1px solid var(--green);*/
    background-color: var(--green);
}
.filter_row {
    display: flex;
    /* align-items: center; */
    flex-wrap: wrap;
}
span.filter_title {
    color: #333333;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: normal;
}
.input-group input {
    border: 1px solid #c6cbd4;
    border-radius: 0;
    height: 30px;
    max-width: 100px;
    font-size: 14px;
}


@media(max-width: 767px){
    .filter_row_mod {
        overflow-x: scroll;
        overflow-y: hidden;
        flex-wrap: unset;
    }
    .filterbox {
        border: 1px solid #ccc;
        border-radius: 4px;
        margin-right: 10px;
        min-width: 80px;
        padding: 10px;
        min-height: 80px;
        justify-content: center;
        flex-direction: column;
    }
    .shape_label {
        font-weight: 400;
        font-size: 14px;
        color: #6a6161;
        text-transform: capitalize;
        margin-top: 4px;
    }
    .filterbox.active .shape_label {
        color: #fff;
    }
}
</style>
